import {
  HOME_DELETE_TOTP_BEGIN,
  HOME_DELETE_TOTP_SUCCESS,
  HOME_DELETE_TOTP_FAILURE,
  HOME_DELETE_TOTP_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderAuthHeader, errorLogOut } from '../../common/utils/auth';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';

export function deleteTotp(args = {}) {
  return (dispatch) => {
    dispatch({
      type: HOME_DELETE_TOTP_BEGIN,
    });

    const config = builderAuthHeader();
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_ORGANIZATION_ENGINE_URL}totp/remove`,
        config,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_DELETE_TOTP_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
          if (res.data.code === 200) {
            toast.success(res.data.message);
          }
        },
        (err) => {
          dispatch({
            type: HOME_DELETE_TOTP_FAILURE,
            data: { error: err },
          });
          reject(err);
          if (err.response.status === 401) {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Session Expired',
            }).then((result) => {
              if (result.value) {
                errorLogOut();
              }
            });
          } else if (err.data && err.data.message) {
            toast.error(err.data.message);
          } else {
            toast.error('Oops! Something went wrong');
          }
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteTotpError() {
  return {
    type: HOME_DELETE_TOTP_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_DELETE_TOTP_BEGIN:
      return {
        ...state,
        deleteTotpPending: true,
        deleteTotpError: null,
      };

    case HOME_DELETE_TOTP_SUCCESS:
      return {
        ...state,
        deleteTotpPending: false,
        deleteTotpError: null,
      };

    case HOME_DELETE_TOTP_FAILURE:
      return {
        ...state,
        deleteTotpPending: false,
        deleteTotpError: action.data.error,
      };

    case HOME_DELETE_TOTP_DISMISS_ERROR:
      return {
        ...state,
        deleteTotpError: null,
      };

    default:
      return state;
  }
}
